import type { FieldSchemaModel } from '@/shared/generated'
import type { StateCreator } from 'zustand'
import type { IField } from '../../fields/types'

export type FiledsSliceShape = {
	schema: FieldSchemaModel[]
	rawSchema: FieldSchemaModel[]
	fieldMap: Record<string, IField>
	setFieldMap: (fieldMap: Record<string, IField>) => void
}
export const createFieldsSlice: StateCreator<FiledsSliceShape> = (set) => ({
	schema: [],
	rawSchema: [],
	fieldMap: {},
	setFieldMap: (fieldMap) => set({ fieldMap }),
})
